import { AllowedCallTypes, CrudConfig } from "seneca-common/utils/apiStates";

export const PATH_TO_TEACHER_ASSIGNMENTS_STATE = "teacherAssignments";

export const ACTION_TYPE_ROOT = "seneca/assignments/teacher/";

const META_ACTION_TYPE_ROOT = `${ACTION_TYPE_ROOT}meta`;

export const classCurrentAssignmentsFetchStateConfig: CrudConfig = {
  name: "future-teacher-assignments",
  path: META_ACTION_TYPE_ROOT,
  idFieldName: "classId",
  callTypes: [AllowedCallTypes.FETCH]
};

export const classAllAssignmentsFetchStateConfig: CrudConfig = {
  name: "all-teacher-assignments",
  path: META_ACTION_TYPE_ROOT,
  idFieldName: "classId",
  callTypes: [AllowedCallTypes.FETCH]
};

export const individualAssignmentsStateConfig: CrudConfig = {
  name: "teacher-assignments",
  path: META_ACTION_TYPE_ROOT,
  idFieldName: "id",
  callTypes: [
    AllowedCallTypes.CREATE,
    AllowedCallTypes.UPDATE,
    AllowedCallTypes.DELETE,
    AllowedCallTypes.FETCH
  ]
};
